import {ArrowLeft} from 'lucide-react';
import type {FullCardBenefitFragment} from '@transactions/graphql';

const formatCents = (cents: number): string => {
  const dollars = Math.abs(cents) / 100;
  return `$${dollars.toFixed(2)}`;
};

const totalRemaining = (benefit: FullCardBenefitFragment): number =>
  benefit.periods.reduce((sum, p) => sum + p.remainingAmount, 0);

const totalAmount = (benefit: FullCardBenefitFragment): number =>
  benefit.periods.reduce((sum, p) => sum + p.amount, 0);

export const BenefitSummary = ({
  benefit,
  feePeriodPayee,
  onBack,
}: {
  benefit: FullCardBenefitFragment;
  feePeriodPayee?: string | null;
  onBack?: () => void;
}) => {
  const remaining = totalRemaining(benefit);
  const total = totalAmount(benefit);
  return (
    <div className="border-border flex items-center gap-3 rounded-md border p-3">
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          className="text-muted-foreground hover:text-foreground shrink-0"
        >
          <ArrowLeft className="h-4 w-4" />
        </button>
      )}
      <div className="flex min-w-0 flex-1 flex-col">
        <span className="text-sm font-medium">{benefit.name}</span>
        {feePeriodPayee && (
          <span className="text-muted-foreground text-xs">
            {feePeriodPayee}
          </span>
        )}
      </div>
      <span className="text-muted-foreground shrink-0 text-xs">
        {formatCents(remaining)} / {formatCents(total)}
      </span>
    </div>
  );
};
